import React, { useState} from 'react';

const ListaTiposServicios = ({ tiposServicios }) => {

  return (
    <div className="flex flex-col w-full space-y-3">
      {tiposServicios.map((servicio, index) => (
        <div key={index} className="flex items-center">
            <span>{servicio}</span>
        </div>
    ))}

    </div>
  );

};

export default ListaTiposServicios;